import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { SwiftIdApplicationStatusCollection } from './swift-id-application-status.types';

export function swiftIdApplicationStatusBackend(): Backend<SwiftIdApplicationStatusCollection> {
  return {
    defaultOrder: {
      field: 'createdAt',
      direction: OrderByDirection.DESC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'swift-id/applications.php',
      method: 'GET',
      isGaf: true,
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
